import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';


import UserStore from './app/stores/UserStore';
import Routes from './routes';
import LoginView from './app/components/admin/user/loginView.react';

export default class App extends Component {

    constructor(props) {
        super(props);

        this._onAuthChange = this._onAuthChange.bind(this);
        this.state = {
            auth: false
        }
    }

    componentDidMount() {
        console.log("[App] - componentDidMount");
        UserStore.addChangeListener(this._onAuthChange);
    }

    componentWillUnmount() {
        console.log("[App] - componentWillUnmount");
        UserStore.removeChangeListener(this._onAuthChange);
    }

    _onAuthChange(payload) {
        console.log("[App] - store event received: ", payload);
        this.setState({auth: UserStore.user() !== null});
    }

    render() {
        var u = UserStore.user();

        if (u) {
            return (<Routes/>);
        } else {
            return (
                <div>
                    <BrowserRouter>
                        <div>
                            <Switch>
                                <Route component={LoginView}/>
                            </Switch>
                        </div>
                    </BrowserRouter>
                    <div><a  target='_blank' href="https://apps.apple.com/us/app/lift-link/id1534102065"><img className="center" style={{width: '164px', height: '70px'}}
                                                                                             src="/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt=""/></a></div>
                    <div><a  target='_blank' href="https://play.google.com/store/apps/details?id=com.lutrons.savaria"><img className="center" style={{width: '184px', height: '70px'}}
                                                                                                          src="/images/google-play-badge.png"
                                                                                                          alt=""/></a></div>
                </div>

            );
        }
    }
}




// WEBPACK FOOTER //
// ./src/App.js